import React from 'react'
import "./ServicesApproachCarasoul.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {Autoplay} from "swiper/modules"
import ServiceCard from './serviceCard';

const cardData = [
    {
        name:"Sport medicine",
        link:"/sports-medicine",
        img:"/images/creatives/service-main-1.webp"
    },
    {
        name:"Audiology",
        link:"/audiology",
        img:"/images/creatives/service-main-2.webp"
    },
    {
        name:"Dna analysis",
        link:"/dna-clinical-testing",
        img:"/images/creatives/service-main-3.webp"
    },
    {
        name:"Global Medical Consulting",
        link:"/global-medical-consulting",
        img:"/images/creatives/service-main-4.webp"
    },
    // {
    //     name:"Gyno uro",
    //     link:"/gyno-uro-clinic",
    //     img:"/images/creatives/service-main-5.webp"
    // },
    {
        name:"Medical aesthetics",
        link:"/medical-aesthetics",
        img:"/images/creatives/service-main-6.webp"
    },
    {
        name:"Aging & wellness",
        link:"/aging-wellness-clinic",
        img:"/images/creatives/service-main-7.webp"
    },
    {
        name:"IV therapy",
        link:"/iv-therapy-boost-shots",
        img:"/images/creatives/service-main-8.webp"
    },
    {
        name:"Naturopathic medicine",
        link:"/naturopathic-medicine",
        img:"/images/creatives/service-main-9.webp"
    },
    {
        name:"Orthopaedic",
        link:"/orthopaedic-clinic",
        img:"/images/creatives/service-main-10.webp"
    },
    // {
    //     name:"Pelvic floor therapy",
    //     link:"/pelvic-floor-therapy",
    //     img:"/images/creatives/service-main-11.webp"
    // },
    // {
    //     name:"Pelvic floor Men",
    //     link:"/mens",
    //     img:"/images/creatives/service-main-11.webp"
    // },
    // {
    //     name:"Pelvic floor Women",
    //     link:"/women",
    //     img:"/images/creatives/service-main-11.webp"
    // },
]




function ServicesApproachCarasoul() {

    const handlePrevButtonClick = () => {
        const swiperInstance = document.querySelector('#service-approach-cards-slider').swiper;
        swiperInstance.slidePrev();
      };
      
      const handleNextButtonClick = () => {
        const swiperInstance = document.querySelector('#service-approach-cards-slider').swiper;
        swiperInstance.slideNext();
      };
  return (
    <div className='ServicesApproachCarasoul-container '>
        <div className='container mt-3 '>


                <Swiper
                    spaceBetween={50}
                    autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                    }}
                    loop={true}
                    // modules={[Autoplay]}
                    navigation={
                        {
                          nextEl: '.swiper-button-next',
                          prevEl: '.swiper-button-prev',
                        }
                        }
                    breakpoints={{
                        200:{
                        slidesPerView: 1,
                        },
                        1100: {
                        slidesPerView: 4,
                        }
                    }}
                    pagination={{ clickable: true }}
                    observer ={true}
                    observeParents={true}
                    parallax={true}
                    className=" px-3 px-md-5 py-4"
                    style={{position:"relative"}}
                    id="service-approach-cards-slider"
                    >
                    
                    
                <div className="swiper-button-prev swiper-button d-lg-block d-none" onClick={handlePrevButtonClick}> 
                <img src="/images/icons/indus-carousel-arrow-left.png" className="arrow-img" alt='arrow icon'/>
                </div>
                {
                        cardData.map((ele,ind)=>{
                        return(<>
                            <SwiperSlide>
                                <ServiceCard
                                    icon={ele.img}
                                    heading={ele.name}
                                    content={""}
                                    btnText={""}
                                    btnRef={ele.link}
                            
                                />
                            </SwiperSlide>
        
                            </>)
                        })
                    }
                    <div className="swiper-button-next swiper-button d-lg-block d-none" onClick={handleNextButtonClick}>
                    <img src="/images/icons/indus-carousel-arrow-right.png" className="arrow-img" alt='arrow icon'/>
                    </div>
                </Swiper>
                </div>
    </div>

  )
}

export default ServicesApproachCarasoul